var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.643,
    height: 14.064,
    viewBox: "0 0 12.643 14.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47837",
    "data-name": "Group 47837",
    transform: "translate(-7555.5 11852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_core-reload",
    "data-name": "Icon core-reload",
    d: "M8.517,6.206h5.456V.75h-.917V4.587l-.749-.749a5.846,5.846,0,1,0,0,8.267l-.648-.648a4.929,4.929,0,1,1,0-6.97l.8.8H8.517Z",
    transform: "translate(7553.67 -11852.25)",
    fill: "#395576",
    stroke: "#395576",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateIcon);
export default __webpack_public_path__ + "static/media/generate_icon.e22697d2.svg";
export { ForwardRef as ReactComponent };